var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{ref:"apexChart",staticClass:"custom_pie_chart",attrs:{"width":380,"type":"pie","series":[..._vm.graphData.series],"options":{
    chart: {
      id: `vuechart-${_vm.graph.id}`,
      zoom: {
        enabled: false
      },
      toolbar: {
        show: true,
        export: {
          csv: {
            filename: `${_vm.graph.name}`
          },
          svg: {
            filename: `${_vm.graph.name}`
          },
          png: {
            filename: `${_vm.graph.name}`
          }
        }
      }
    },
    labels: [..._vm.graphData.labels],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }